'use client';

import { useTheme } from 'next-themes';

import { useIsClient } from '../hooks/useIsClient';
import { ToggleGroup, ToggleGroupItem } from './ToggleGroup';

const THEME_OPTIONS = [
  { value: 'light', label: 'Light' },
  { value: 'dark', label: 'Dark' },
  { value: 'system', label: 'System' },
] as const;

export function ThemeSelector() {
  const { theme, setTheme } = useTheme();
  const mounted = useIsClient();

  if (!mounted) {
    return (
      <ToggleGroup defaultValue="system" type="single" variant="bounded">
        {THEME_OPTIONS.map((option) => (
          <ToggleGroupItem key={option.value} value={option.value}>
            {option.label}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
    );
  }

  return (
    <ToggleGroup
      onValueChange={(value) => value && setTheme(value)}
      type="single"
      value={theme}
      variant="bounded"
    >
      {THEME_OPTIONS.map((option) => (
        <ToggleGroupItem key={option.value} value={option.value}>
          {option.label}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  );
}
